export default {
    name: "promotion_tiles",
    items: [{
        id: 1,
        medial_url: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1600844498/botswana%20services/promotions/promo_stationary_t8gddn.jpg",
        title: "2020 End Of Year Cutt Offs",
        sub_title: "5 days left",
        views_count: 14557,
        company: {
            id: 1,
            name: "Solidcare (pty) ltd",
            logo_url: ""
        }
    },{
        id: 2,
        medial_url: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1600844511/botswana%20services/promotions/promo_sefalana_ef6jhk.jpg",
        title: "Spectacular Month End",
        sub_title: "3 days left",
        views_count: 3453,
        company: {
            id: 3,
            name: "seffalana cash and carry (pty) ltd",
            logo_url: ""
        }
    },{
        id: 3,
        medial_url: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1600850059/botswana%20services/promotions/promo_funiture_uu77dw.jpg",
        title: "Greate Product Discounts",
        sub_title: "5 days left",
        views_count: 5678,
        company: {
            id: 4,
            name: "Funituremart",
            logo_url: ""
        }
    }]
}